var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Fill-3",
    d: "m55.5,18.8l-1.9,-1.9l-17.6,17.6c-2.2,2.2 -5.9,2.2 -8.1,0l-17.6,-17.5l-1.9,1.9l13.1,13.1l-13.1,13.1l1.9,1.9l13.1,-13.1l2.6,2.6c1.6,1.6 3.7,2.5 5.9,2.5s4.3,-0.9 5.9,-2.5l2.6,-2.6l13.1,13.1l1.9,-1.9l-13.1,-13.1l13.2,-13.2",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Fill-4",
    d: "m51.8,50.4l-39.5,0c-2.3,0 -4.2,-1.9 -4.2,-4.2l0,-28.2c0,-2.3 1.9,-4.2 4.2,-4.2l39.5,0c2.3,0 4.2,1.9 4.2,4.2l0,28.2c0,2.3 -1.9,4.2 -4.2,4.2l0,0zm-39.6,-33.9c-0.8,0 -1.4,0.6 -1.4,1.4l0,28.2c0,0.8 0.6,1.4 1.4,1.4l39.5,0c0.8,0 1.4,-0.6 1.4,-1.4l0,-28.2c0,-0.8 -0.6,-1.4 -1.4,-1.4l-39.5,0l0,0z",
    className: "st0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.78c02d74adc27aa4d771f20265c9d109.svg";
export { ForwardRef as ReactComponent };